module.exports = __webpack_public_path__ + "img/content_copy-24px.89116101.svg";